import { AppBar, Container, Box, Typography, Link, IconButton,  Menu, List, ListItem,  } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAppBar = styled(AppBar)(({  }) => ({
  background: '#fff',
  borderBottom: '1px solid #DADADA',
  position: 'relative',
  zIndex: 2,
}));

export const StyledContainer = styled(Container)(({ theme }) => ({
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
  },
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(3.75),
    paddingRight: theme.spacing(3.75),
  },
}));

export const HeaderBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
  minHeight: '74px',
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
}));

export const LogoLink = styled(Link)(({  }) => ({
  display: 'inline-flex',
}));

export const NotificationIconButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: '42px',
  minHeight: '42px',
  marginRight: theme.spacing(0.75),
  backgroundColor:'#F3F3F3',
  '&.yellow':{
    backgroundColor: '#FFEFC7',    
  },
  '&.blue':{
    backgroundColor: '#DDEBFF',    
  },
  'img':{
    display:'block',
    width: 24,
    height: 'auto',
  },
  [theme.breakpoints.up('sm')]: {
    marginRight: theme.spacing(1.75),
  },
}));

export const UserBox = styled(Box)(({  }) => ({
  display: 'inline-flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
  flexShrink: 0,
}));

export const AvatarWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0.25),
  border: '2px solid #00D689',
  borderRadius: '100px',
}));

export const UserInfoBox = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  flexDirection: 'column',
  paddingLeft: theme.spacing(1.75),
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const UserNameTypography = styled(Typography)(({  }) => ({
  display: 'block',
  color: '#3F3F44',
  fontSize: '14px',
  lineHeight: '18px',
  fontWeight: 600,
}));

export const UserRoleTypography = styled(Typography)(({  }) => ({
  display: 'block',
  color: '#3F3F44',
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 400,
}));

// NOTIFICATION START

export const NotificationMenu = styled(Menu)(({  }) => ({
  '& .MuiList-root':{
    width: 320,
    padding: 0,
    maxHeight: 300,
    overflow:'auto',
    borderRadius: '12px',
  }
}));

export const NotificationLists = styled(List)(({ theme }) => ({
  display: 'block',
  margin: theme.spacing(2.5, 0, 0, 0),
  padding: 0,
}));

export const NotificationListItem = styled(ListItem)(({  }) => ({
  display: 'block',
  border: 'none',
  padding: 0,
  margin: 0,
  '&:not(:last-child)':{
      // marginBottom: theme.spacing(1.5),
      // borderBottom: '1px solid #cfd7e2',
  }
}));

export const NotificationLink = styled(Link)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
    backgroundColor:'#fff',
    padding: theme.spacing(1.25 , 2),
    borderBottom: '1px solid #d7dfeb',
    transition: '500ms',
    textDecoration: 'none',
    cursor:'pointer',
    '&:not(.read)':{
        backgroundColor:'#d2d9e2',
        // boxShadow: '0 4px 5px 0px rgb(191 197 215)',
        // borderColor: '#a3aebe',
    },
    '&:hover':{
        backgroundColor: '#002f73',
        '& .MuiListItemText-root':{
            margin: 0,
            '& h6':{
                color:'#fff',
            },
            '& .MuiListItemText-secondary':{
                '& .MuiTypography-root:first-of-type':{
                    color:'#fff'
                },                
            }
        },
        '& .MuiListItemAvatar-root':{
            '& .MuiAvatar-root':{
                backgroundColor: '#fff',
                '& img':{
                    filter: 'none',
                },
            },
        },
    },
    '& .MuiListItemAvatar-root':{
        margin: 0,
        minWidth: 50,
        '& .MuiAvatar-root':{
            backgroundColor: '#002f73',
            width: 42,
            height: 42,
            '& img':{
              filter: 'brightness(0) invert(1)',
            },
        },
    },
    '& .MuiListItemText-root':{
        margin: 0,
        '& h6':{
            display: 'block',
            color:'#222',
            fontSize: 13,
            lineHeight: '17px',
            fontWeight: 500,
        },
        '& .MuiListItemText-secondary':{
            display: 'block',
            marginTop: theme.spacing(0.75),
            '& .MuiTypography-root:first-of-type':{
                display: 'block',
                fontSize: 12,
                lineHeight: '16px',
                fontWeight: 500,
                color:'#848484'
            },
            '& .MuiTypography-root:not(:first-of-type)':{
                display: 'block',
                fontSize: 12,
                lineHeight: '16px',
                fontWeight: 500,
                marginTop: theme.spacing(0.25),
                color: theme.palette.error.main,
                // '&.read':{
                //   color: theme.palette.success.main,
                // }
            },
            
        }
    }
}));
